export const LOGIN_PAGE = "/login";

export const LANDING_PAGE = "/";

export const USERS = "/users";
export const LABELING_MODEL = "/label-model";
export const DATA_REVIEW_MODAL = "/data-review-modal";
export const LABELED_DATA = "/labeled-data/posts";
export const LABELED_DATA_C = "/labeled-data/comments";
